import { t } from '@lingui/core/macro';
import { MetadataAllowedValuesFilter } from './MetadataAllowedValuesFilter';
export const countryFilterLabel = () => t({ message: 'Country', comment: 'Insights filter: Country' });
export function CountryFilter() {
    return <MetadataAllowedValuesFilter name="Country" field="metadataDocumentCountry" label={countryFilterLabel()}/>;
}
